var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { getStyles } from './Icons';
export function IconArrow(_a) {
    var _b = _a.fill, fill = _b === void 0 ? false : _b, _c = _a.duotone, duotone = _c === void 0 ? true : _c, _d = _a.direction, direction = _d === void 0 ? 'right' : _d, props = __rest(_a, ["fill", "duotone", "direction"]);
    var getRotation = function () {
        switch (direction) {
            case 'up':
                return -90;
            case 'down':
                return 90;
            case 'left':
                return 180;
            case 'right':
            default:
                return 0;
        }
    };
    var baseStyles = getStyles(props);
    var styles = __assign(__assign({}, baseStyles), { transform: "rotate(".concat(getRotation(), "deg)") });
    if (!fill) {
        return (React.createElement("svg", { focusable: "false", style: styles, "aria-hidden": "true", viewBox: "0 0 24 24", role: "presentation", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React.createElement("path", { d: "M4 12H20M20 12L14 6M20 12L14 18", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })));
    }
    return (React.createElement("svg", { focusable: "false", style: styles, "aria-hidden": "true", viewBox: "0 0 24 24", role: "presentation", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { opacity: duotone ? '0.5' : '1', fillRule: "evenodd", clipRule: "evenodd", d: "M3.25 12C3.25 11.5858 3.58579 11.25 4 11.25H13.25V12.75H4C3.58579 12.75 3.25 12.4142 3.25 12Z", fill: "currentColor" }),
        React.createElement("path", { 
            // eslint-disable-next-line max-len
            d: "M13.25 12.75V18C13.25 18.3034 13.4327 18.5768 13.713 18.6929C13.9932 18.809 14.3158 18.7449 14.5303 18.5304L20.5303 12.5304C20.671 12.3897 20.75 12.1989 20.75 12C20.75 11.8011 20.671 11.6103 20.5303 11.4697L14.5303 5.46969C14.3158 5.25519 13.9932 5.19103 13.713 5.30711C13.4327 5.4232 13.25 5.69668 13.25 6.00002V11.25V12.75Z", fill: "currentColor" })));
}
//# sourceMappingURL=IconArrow.js.map